(function(angular) {
    'use strict';
    // Creates the `enervee.a11y` module
    var app = angular.module('enervee.a11y', []);

    /**
     * An accessibility helper attribute directive for trapping tab focus
     * within a dialog or modal window. Usually not required for uib-modals,
     * but for use with custom full-screen dialogs.
     * https://a11yproject.com/about#what-does-the-term-a11y-mean
     */
    app.directive('a11yTrapTabFocus', a11yTrapTabFocusDirective);

    a11yTrapTabFocusDirective.$inject = [
        'UtilService',
    ];
    function a11yTrapTabFocusDirective(
        UtilService
    ) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                /**
                 * Helper function to get all focusable elements within the
                 * element this directive is applied to.
                 *
                 * NOTE: this is not a bulletproof solution, since custom
                 * elements that can be focused on may be possible, but it's
                 * the best we can do for the moment with the elements we're
                 * aware of.
                 * @returns {Array<Element>} an array of focusable DOM nodes
                 */
                function getFocusableElements() {
                    var focusableSelectors = [
                        'a[href]',
                        'area[href]',
                        'input:not([disabled])',
                        'select:not([disabled])',
                        'textarea:not([disabled])',
                        'button:not([disabled])',
                        'iframe',
                        'object',
                        'embed',
                        '*[tabindex]',
                        '*[contenteditable]',
                    ];
                    var elements = elem
                        .find(focusableSelectors.join(', '))
                        .filter(':visible');
                    /**
                     * Return results sorted by increasing tabIndex, excluding
                     * any elements with a tabindex of -1, which indicates an
                     * element that cannot be focused.
                     *
                     * NOTE: we compare the original indicies here when the
                     * tab indicies are equal because returning `0` for
                     * `Array.prototype.sort` isn't "stable":
                     * https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
                     */
                    elements = Array.prototype.slice.call(elements);
                    return elements.sort(function(a, b) {
                        if (a.tabIndex === b.tabIndex) {
                            return elements.indexOf(a) - elements.indexOf(b);
                        }
                        return a.tabIndex - b.tabIndex;
                    }).filter(function(el) {
                        return el.tabIndex > -1;
                    });
                }

                elem.bind('keydown', function (e) {
                    /**
                     * If the tab key is pressed within the element, make
                     * sure that the focus is trapped within the element.
                     *
                     * NOTE: this handler is triggered _before_ focus changes,
                     * so document.activeElement is the element focused when
                     * the tab key is pressed.
                     */
                    if (e.which === 9) {
                        /**
                         * Get focusable elements when the tab key is pressed
                         * but not before, since elements could have been added
                         * or removed before the keypress.
                         */
                        var focusableElements = getFocusableElements();
                        var focusedIndex = focusableElements.indexOf(document.activeElement);
                        var lastIndex = focusableElements.length - 1;
                        if (focusedIndex === 0 && e.shiftKey) {
                            /**
                             * If the currently focused element is the first in
                             * the modal and the shiftKey is pressed, then
                             * focus on the last element in the modal
                             */
                            e.preventDefault();
                            UtilService.focusElement(focusableElements[lastIndex]);
                        } else if (focusedIndex === lastIndex) {
                            e.preventDefault();
                            UtilService.focusElement(focusableElements[0]);
                        }
                    }
                });
            },
        };
    }
})(angular);
